var map = {
	"./apple_icon.svg": 491,
	"./arrow.svg": 113,
	"./calendar_date_icon.svg": 165,
	"./exercise.svg": 76,
	"./icon_attention.svg": 492,
	"./icon_good.svg": 245,
	"./logo-white.svg": 244,
	"./orange.svg": 75,
	"./splash-blue.svg": 493,
	"./warning_icon.svg": 494
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 490;